import React, { FC } from 'react'
import { Typography } from '../../Typography'

const Title: FC = ({ children }) =>
  <Typography color={'white'} variant={'label5'} mb={'s'}>
    {children}
  </Typography>

export default Title
